module.exports = __webpack_public_path__ + "static/juli-y-ana-transparente-e072fa7db8929d3a081e10de5213bd41.png";